import { createSlice } from '@reduxjs/toolkit';
import { productGroupCreate } from './productGroupAsyncThunk';

const productGroupCreateSlice = createSlice({
  name: "productGroup",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [productGroupCreate.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [productGroupCreate.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [productGroupCreate.rejected]: (state, action) => {
      state.isLoading = false;
      state.isFail = true;
    },
  },
});

export default productGroupCreateSlice.reducer;